export enum Category {
    specimenTypes = 1,
    specimensVolumes = 2,
    testsTime = 4,
    measurementsUnits = 5,
    instructions = 6,
    specimenContainers = 7,
    specimenCancellationReason = 8
}